<template>
  <v-bottom-navigation color="primary" grow app>
    <v-btn value="home" :to="{ path: '/' }" text>
      <span>Home</span>
      <v-icon>mdi-home-variant-outline</v-icon>
    </v-btn>

    <v-btn value="favorite" :to="{ path: '/profile/favorites' }" text>
      <span>Favorite</span>
      <v-icon>mdi-heart-outline</v-icon>
    </v-btn>

    <v-btn
      value="chats"
      :to="{ name: 'chat-list' }"
      text
      v-if="getUnreadCount > 0"
    >
      <v-badge dot color="red" overlap>
        <div class="text-center">
          <v-icon>mdi-chat-outline</v-icon>
          <div>Chats</div>
        </div>
      </v-badge>
    </v-btn>

    <v-btn v-else value="chats" :to="{ name: 'chat-list' }" text>
      <span>Chats</span>
      <v-icon>mdi-chat-outline</v-icon>
    </v-btn>

    <v-btn value="profile" :to="{ name: 'user-profile' }" text>
      <span>Profile</span>
      <v-icon>mdi-account-outline</v-icon>
    </v-btn>
  </v-bottom-navigation>
</template>

<script>
import { mapGetters } from "vuex/dist/vuex.common.js";

export default {
  data() {
    return {
      active: "home", // default selected tab
    };
  },
  computed: {
    ...mapGetters("chat", ["getUnreadCount"]),
  },
  watch: {
    // optional: sync active with route changes
    $route(to) {
      if (to.name === "Home") this.active = "home";
      else if (to.name === "Chats") this.active = "chats";
      else if (to.name === "Profile") this.active = "profile";
    },
  },
};
</script>

<style scoped>
/* optional: style icon-only or hide labels on mobile, etc. */
.v-bottom-navigation .v-btn span {
  font-size: 0.75rem;
}
</style>